import React from 'react'
import { makeStyles } from '@material-ui/core'
import { Typography, Button } from 'foundations-library/components'

const jss = () => ({
    numbersLandingPage: {
        maxWidth: 650,
        margin: '0 auto'
    },
    imgContainer: {
        padding: '0 20px',
        marginBottom: 40
    },
    image: {
        width: '100%',
        display: 'block'
    },
    title: {
        marginBottom: 10
    },
    buttonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 40
    }
})

const useStyles = makeStyles(jss)

interface PropsInterface {
    onClickAddNew(): unknown
}

/**
 *
 */
const NumbersLandingPage = ({ onClickAddNew }: PropsInterface): JSX.Element => {
    const styles = useStyles()

    return (
        <div className={styles.numbersLandingPage}>
            <div className={styles.imgContainer}>
                <img
                    src="https://s3.us-west-2.amazonaws.com/assets.phone.com/sms-registration/man-on-phone.png"
                    alt="man-on-phone"
                    className={styles.image}
                />
            </div>
            <Typography variant='h4' className={styles.title} align='center'>
                Start Number Assignment
            </Typography>
            <Typography align='center'>
                Choose which numbers you want your Campaign to be assigned to.
            </Typography>
            <div className={styles.buttonContainer}>
                <Button icon='add' iconLeft onClick={onClickAddNew}>
                    Add number(s)
                </Button>
            </div>
        </div>
    )
}

export default NumbersLandingPage
